export const OTP_DATA = {
    OTP_TIMEOUT : 0.5,
    OTP_RESEND_TIME : 180,
    OTP_SEND_SMS : "SMS",
    OTP_SEND_WHATSAPP : "Whatsapp",
}